import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TitleTransformPipe } from '@shared/pipes/title-transform.pipe';
import { ExtractionsService } from '@modules/extractions/extractions.service';

@Component({
  selector: 'app-entity-viewer',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    TitleTransformPipe,
  ],
  templateUrl: './entity-viewer.component.html',
  styleUrl: './entity-viewer.component.scss',
})
export class EntityViewerComponent {
  @Input() entities: any;
  @Input() saveContract: any;
  collapsedState: { [key: string]: boolean } = {}; // Track collapsed state for each group

  constructor(protected _extraction: ExtractionsService) {}

  ngOnInit() {
    // Initialize collapsed state for all keys
    Object.keys(this.entities).forEach((key) => {
      this.collapsedState[key] = false;
    });
  }

  toggleCollapse(key: string) {
    this.collapsedState[key] = !this.collapsedState[key];
  }

  Object = Object;

  typeOfValue(value: any) {
    if (typeof value === 'string') {
      let num = parseFloat(value);
      if (!isNaN(num)) {
        return 'string';
      }
      let date = new Date(value);
      if (
        date.toString() !== 'Invalid Date' &&
        date.getHours() + date.getMinutes() + date.getSeconds() > 0
      ) {
        return 'date';
      }
      return 'string';
    } else if (typeof value === 'number') {
      return 'number';
    } else if (typeof value === 'object') {
      //console.log("'object' in value);,", value);
      if (Array.isArray(value)) {
        if (Array.isArray(value[0])) {
          return 'array of array';
        } else if (typeof value[0] === 'object') {
          if (typeof value[0][Object.keys(value[0])[0]] === 'object') {
            return 'array of object of object';
          }
          return 'array of object';
        } else if (typeof value[0] === 'string') {
          return 'array of string';
        }
        return 'array';
      } else {
        return 'object';
      }
    }
    return typeof value;
  }

  manageSuffix = (key: string, value: any) => {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    if (value.length < 1) {
      return 'N/A';
    }
    if (key.toLowerCase().includes('cost')) {
      return '$ ' + value;
    } else if (key.toLowerCase().includes('percentage')) {
      let newValue = parseFloat(value);
      if (typeof newValue === 'number') {
        return newValue * 100 + '%';
      }
      return value;
    } else if (key.toLowerCase().includes('date')) {
      let date = new Date(value);

      if (date.toString() !== 'Invalid Date') {
        return (
          date.getDate() +
          '-' +
          date.toLocaleString('default', { month: 'short' }) +
          '-' +
          date.getFullYear()
        );
      }
      return value;
    } else {
      return value;
    }
  };

  checkObjectOfObjectType(value: any) {
    if (value === null || value === undefined) {
      return 'string';
    }
    return typeof value;
  }

  getObjectKeyValue(key: any, value: any) {
    let obj = {
      [key]: value,
    };
    return obj;
  }

  trackByFn(index: any, item: any) {
    return index;
  }
}
